import React from "react";
import Box, { BoxProps } from "@material-ui/core/Box";
import { styled } from "@material-ui/core/styles";
import theme from "theme";
const StyledBox = styled(Box)({
  position: "relative",
  padding: `${theme.spacing(2)}px ${theme.spacing(4)}px`,
  color: "white",
  height: theme.spacing(7),
  borderRadius: "10px 10px 0 0",
  display: "flex",
  justifyContent: "space-between",
  //Font setting equivalent to Title3
  fontSize: 21,
  lineHeight: "130%",
  letterSpacing: "-1px",
  fontWeight: 500,
});

type CardHeaderProps = {
  bgcolor?: string;
} & BoxProps;

const CardHeader: React.FC<CardHeaderProps> = ({ children, bgcolor = "#005646", ...BoxProps }) => {
  return (
    <StyledBox bgcolor={bgcolor} {...BoxProps}>
      {children}
    </StyledBox>
  );
};

export default CardHeader;
